import React from 'react';

import Advertising from './_advertising';
import Preface from './_preface';
import Header from './_header';
import Actions from './_actions';
import Partners from './_partners';

const ImpactView = () => {

  return (
    <>
      <Header />
      <Preface />
      <Actions />
      <Advertising />
      <Partners />
    </>
  );
}

export default ImpactView;
